export default __webpack_public_path__ + "static/media/Roboto-Light.d592a653.eot";